/**
 * Convert number to correct currency format
 * @param thereof_paid
 * @param total_cost
 * @return number - remaining Percentage
 */

export const calcRemainingPercentage = (thereof_paid: number, total_cost: number ): number => {
  return Math.round(( 1 - (+thereof_paid / +total_cost) ) * 100)
}
